import './App.css';
// import Search from './components/Search';
import { useState, useEffect } from 'react';
import { Donate } from 'react-kofi-overlay';
import Backdrop from '@mui/material/Backdrop';
import MTGMap from './components/MTGMap';
import { IconButton, Box  } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Info from './components/Info';
import infoPre from './data/tutorial_hq.png';
import MobileDisplay from './components/MobileDisplay';
// import { useState } from 'react';

const DISPLAYS = {
    color: 'color',
    display: 'display',
    keyword: 'keyword',
    power: 'power',
    text: 'text',
    type: 'type',
}

function App() {
  const [isOpen, setOpen] = useState(false);
  const [useColors] = useState(true);
  const [currentCoord, setCoords] = useState('text');
  const [start, setStart] = useState('firstTime' in sessionStorage ? false : true);
  const [width, setWidth] = useState(-1);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setWidth(window.innerWidth);
            window.addEventListener('resize', () => {setWidth(window.innerWidth)});
            return () => {
                window.removeEventListener('resize', () => {setWidth(window.innerWidth)});
            }
        }
    }, []);

    const isMobile = width <= 1000;

  const handleChange = (event) => {
    setCoords(DISPLAYS[event.target.value]);
  };
  
  return isMobile ? <MobileDisplay setStart={setStart} useColors={useColors} currentCoord={currentCoord} handleChange={handleChange} setOpen={setOpen} isOpen={isOpen} start={start} /> : (
    <div className="App">
        <Backdrop
            sx={{
                color: '#ffffff00',
                zIndex: 20,
                height: '100vh',
                width: '100vw',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'absolute',
                top: 0,
                left: 0,
            }}
            open={start}
            onClick={() => {sessionStorage.setItem('firstTime', false); setStart(false)}}
        >
            <Box>
                <IconButton style={{position: 'absolute',top: '10px',right: '10px',color: 'white',backgroundColor: '#ccccccbb', zIndex: 10}} onClick={() => {setStart(false) }}>
                        <CloseIcon />
                </IconButton>
            </Box>
            <img src={infoPre} alt="card before clicking" style={{width: '100%', height: 'auto', position: 'flex', zIndex: 5}}></img>
            </Backdrop>
        <MTGMap useColors={useColors} currentCoord={currentCoord} handleChange={handleChange} setOpen={setOpen} open={isOpen}/>
        <Donate
            username="martirubio"
            classNames={{
                donateBtn: 'myDonateButton',
                profileLink: 'myProfileLink',
            }}
            styles={{
                donateBtn: {
                    position: 'absolute',
                    // color: 'black',
                    right: '3%',
                    bottom: '3%',
                    background: '#01204E'
                },
                panel: {
                    position: 'absolute',
                    // color: 'black',
                    height: '80%',
                    right: '1%',
                    borderRadius: '100px',
                    background: '#01204E'
                },
                fontFamily: 'Montserrat, sans-serif'
            }}
        >
            <div style={{fontFamily: 'Montserrat, sans-serif'}}>
                {"🥳 Support Me"}
            </div>
        </Donate>
        <Backdrop
                sx={{
                    color: '#ffffff00',
                    zIndex: 1,
                    height: '100vh',
                    width: '100vw',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                }}
                open={isOpen}
                onClick={() => setOpen(false)}
            >
            {isOpen && <Info sx={{zIndex: 2}} setOpen={setOpen}></Info>}
        </Backdrop>
    </div>
  );
}

export default App;
